export const PARSE_DOCUMENT_ACCEPT = 'application/pdf,image/*,.pdf,.png,.jpg,.jpeg';

export const UNSUPPORTED_DOCUMENT_TYPE_MESSAGE =
  'Please upload a PDF or image file (PNG, JPG, etc.). Word documents and other formats are not supported.';

const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'heic', 'heif', 'tif', 'tiff']);

export function isAllowedParseDocumentFile(file) {
  if (!file) return false;

  const mimeType = (file.type || '').toLowerCase();
  if (mimeType === 'application/pdf' || mimeType.startsWith('image/')) {
    return true;
  }

  const extension = (file.name || '').split('.').pop()?.toLowerCase();
  if (extension === 'pdf') return true;
  if (extension && IMAGE_EXTENSIONS.has(extension)) return true;

  return false;
}

export function getDocumentUploadValidationError(file) {
  if (!file) return 'Please choose a file to upload.';
  if (!isAllowedParseDocumentFile(file)) return UNSUPPORTED_DOCUMENT_TYPE_MESSAGE;
  return null;
}

export function getDocumentParseErrorMessage(error) {
  const message = error?.detail || error?.message || '';
  if (!message) return 'Failed to parse document. Please try again.';
  if (message === 'Failed to fetch') {
    return 'Unable to parse this document. Please upload a PDF or image file (PNG, JPG).';
  }
  if (message.startsWith('Failed to parse document:')) return message;
  return `Failed to parse document: ${message}`;
}
